module.exports = __webpack_public_path__ + "img/SmallWechat.f91f8bbe.png";